export default __webpack_public_path__ + "static/media/Elia.65d3f3c4.jpg";